// OS-level app badge (navigator.setAppBadge) — reuses the exact same
// per-user unacknowledged count as the topbar bell (FleetMapLayout's
// scope=mine poll) and the push payload's badge_count (push_notify.py),
// per the "one resolution, not a separate code path" requirement. Feature-
// detected; Safari/iOS support varies and this is a silent no-op where
// unsupported, never an error.

export function isBadgingSupported() {
  return 'setAppBadge' in navigator;
}

export function updateBadge(count) {
  if (!isBadgingSupported()) return;
  try {
    if (count > 0) {
      navigator.setAppBadge(count).catch(() => {});
    } else {
      navigator.clearAppBadge().catch(() => {});
    }
  } catch {
    // Some engines throw synchronously rather than rejecting.
  }
}
